import { render, staticRenderFns } from "./ComAwardItem.vue?vue&type=template&id=2a9000b3&scoped=true"
import script from "./ComAwardItem.vue?vue&type=script&lang=js"
export * from "./ComAwardItem.vue?vue&type=script&lang=js"
import style0 from "./ComAwardItem.vue?vue&type=style&index=0&id=2a9000b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9000b3",
  null
  
)

export default component.exports